import React from "react"
import BlogPreviewImageStyle from "./BlogPreviewImageStyle.module.styl"
import Image from "gatsby-image"

const BlogPreviewImage = ({ image, title,largeImage }) => {
  return (
    <div>
      {largeImage && largeImage ? <Image      alt="blog-preview-image"
                                thumbnailUrl={largeImage}
                                className={BlogPreviewImageStyle.large_image}
                                fluid={largeImage}/> :       <Image
        alt="blog-preview-image"
        thumbnailUrl={image}
        className={BlogPreviewImageStyle.image_holder}
        fluid={image}
      /> }

      <meta property="og:image:alt" content={title} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="300" />
    </div>
  )
}

export default BlogPreviewImage
